export default __webpack_public_path__ + "static/media/pixels-project-4.c5207005.jpg";